import { rem } from 'polished'
import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  background: url('/assets/total-eclipse/texture.jpg') top center no-repeat;
  background-size: 100%;
`

export const Main = styled.div`
  ${tw`relative z-30 mx-auto px-12 box-content`};
  max-width: ${rem(530)};

  li + li {
    margin-top: 0.5em;
  }

  p + p {
    margin-top: 1em;
  }

  @keyframes dash {
    from {
      stroke-dashoffset: 40;
    }
    to {
      stroke-dashoffset: 0;
    }
  }

  .diameter-path {
    stroke-dasharray: 4 4;
    stroke-dashoffset: 0;
    animation: dash 10s linear forwards infinite;
  }
`

export const Spacer = styled.div`
  ${tw`h-12`};
`
